import { Link } from 'react-router-dom';
import VisitorCounter from '../VisitorCounter/VisitorCounter';
import './SiteFooter.css';

const PHONE_NUMBER = '+255625313162';
const WHATSAPP_NUMBER = '+255769565136';

function PhoneIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M6.5 3.5h3l1.2 4.8-1.9 1.1a13 13 0 0 0 5.8 5.8l1.1-1.9 4.8 1.2v3c0 .6-.4 1-1 1C10.8 18.5 5.5 13.2 5.5 4.5c0-.6.4-1 1-1Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function WhatsAppIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 2.07.68 3.98 1.84 5.53L2 22l4.72-1.93a9.86 9.86 0 0 0 5.32 1.55h.01c5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2Zm0 18.08h-.01a8.1 8.1 0 0 1-4.13-1.13l-.3-.18-2.8.69.75-2.73-.19-.29a8.06 8.06 0 0 1-1.24-4.34c0-4.47 3.64-8.11 8.11-8.11s8.11 3.64 8.11 8.11-3.64 8.11-8.11 8.11Zm4.46-6.05c-.24-.12-1.44-.71-1.66-.79-.22-.08-.38-.12-.54.12-.16.24-.62.79-.76.95-.14.16-.28.18-.52.06-.24-.12-1.01-.37-1.93-1.19-.71-.63-1.2-1.41-1.34-1.65-.14-.24-.02-.37.1-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.4.08-.16.04-.3-.02-.42-.06-.12-.54-1.3-.74-1.78-.2-.48-.4-.41-.54-.42h-.46c-.16 0-.42.06-.64.3-.22.24-.84.82-.84 2s.86 2.32.98 2.48c.12.16 1.69 2.58 4.09 3.62.57.25 1.02.4 1.37.51.58.18 1.1.15 1.52.09.46-.07 1.44-.59 1.64-1.16.2-.57.2-1.06.14-1.16-.06-.1-.22-.16-.46-.28Z" />
    </svg>
  );
}

function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <img
            src="/inmotion logo.jpeg"
            alt=""
            className="site-footer__logo"
            width={24}
            height={24}
          />
          <span className="site-footer__name">inmotion</span>
          <a
            href={`tel:${PHONE_NUMBER}`}
            className="site-footer__contact-link"
            aria-label={`Call ${PHONE_NUMBER}`}
          >
            <PhoneIcon />
            <span>{PHONE_NUMBER}</span>
          </a>
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER.replace(/\D/g, '')}`}
            className="site-footer__contact-link site-footer__contact-link--whatsapp"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`WhatsApp ${WHATSAPP_NUMBER}`}
          >
            <WhatsAppIcon />
            <span>{WHATSAPP_NUMBER}</span>
          </a>
        </div>

        <VisitorCounter compact />

        <div className="site-footer__actions">
          <Link to="/admin" className="site-footer__admin-link">
            Staff login
          </Link>
          <span className="site-footer__copyright">&copy; {year} inmotion</span>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
